import { cloneElement, FC, PropsWithChildren } from 'react';

import { Box, ChevronDownOutline, Hide, Popover, PopoverBody, PopoverContent, PopoverTrigger, rem, Show } from '@bonusly/design-system';

interface NavMenuProps extends PropsWithChildren {
	icon: JSX.Element;
	isActive?: boolean;
	id?: string;
	label?: string;
}

export const NavMenu: FC<NavMenuProps> = ({ children, icon, isActive, id, label, ...rest }) => {
	return (
		<Box as="li" id={id}>
			<Popover>
				{({ isOpen }) => (
					<>
						<PopoverTrigger>
							<Box
								as="button"
								alignItems="center"
								backgroundColor={isActive || isOpen ? 'primary.bgAlpha' : 'transparent'}
								borderRadius="md"
								color={isActive || isOpen ? 'primary.fgStrong' : 'text.soft'}
								display="inline-flex"
								fontSize={{ base: '2xl', xs: 'lg' }}
								fontWeight="medium"
								h={rem(44)}
								justifyContent="center"
								px={{ base: 1, sm: 2 }}
								transitionDuration="normal"
								transitionProperty="common"
								w={{ base: rem(44), sm: 'auto' }}
								_hover={{
									textDecor: 'none',
								}}
								{...(isActive && {
									class: 'active',
								})}
								{...rest}
							>
								<Show above="sm">
									{label}
									<ChevronDownOutline
										ml={1}
										size="xs"
										transitionDuration="normal"
										transitionProperty="common"
										{...(isOpen && { transform: 'rotate(180deg)' })}
									/>
								</Show>

								<Hide above="sm">{cloneElement(icon, { size: 'md' })}</Hide>
							</Box>
						</PopoverTrigger>

						<PopoverContent bg="bg.surface" borderColor="border.soft" maxW={rem(254)} aria-label={label}>
							<PopoverBody as="ul" p={1} role="listbox" aria-label={label}>
								{children}
							</PopoverBody>
						</PopoverContent>
					</>
				)}
			</Popover>
		</Box>
	);
};
